let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("in0CI"), load("fe4be"), load("jDjSj"), load("kO0mz")]).then(() => parcelRequire('kYM3c'));